import { ValidationResult, Validator } from '../form-validation'
import { t } from 'i18next'

export const russianPhoneRegexp: RegExp = /^(\+7)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/
export const emailRegexp: RegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const nameRegexp: RegExp = /^[A-ZА-ЯЁӘҒҚҢӨҮҰҺІЇҐЎÆƏÇĞİĢŊÖŞÜŽƵG‘]{1}([a-zа-яёәғқңөүұһіїґўæəçğı̇ļŋöşüžƶ‘\-']{0,50}){0,1}(([\s'‘-][A-ZА-ЯЁӘҒҚҢӨҮҰҺІЇҐЎÆƏÇĞİĢŊÖŞÜŽƵG‘]{1}[a-zа-яёәғқңөүұһіїґўæəçğı̇ļŋöşüžƶ‘\-']{0,50}){0,2})$/
export const excludeApostropheRegexp: RegExp = /^[^']*$/
export const childNameRegexp: RegExp = /^$|^[A-ZА-ЯЁӘҒҚҢӨҮҰҺІЇҐЎÆƏÇĞİĢŊÖŞÜŽƵG‘]{1}([a-zа-яёәғқңөүұһіїґўæəçğı̇ļŋöşüžƶ‘\-']{0,50}){0,1}(([\s'‘-][A-ZА-ЯЁӘҒҚҢӨҮҰҺІЇҐЎÆƏÇĞİĢŊÖŞÜŽƵG‘]{1}[a-zа-яёәғқңөүұһіїґўæəçğı̇ļŋöşüžƶ‘\-']{0,50}){0,2})$/

/**
 * Возвращает функцию валидатор с результатом обработки
 * @param {RegExp} regExp - регулярное выражение
 * @param {string} errorText - текст ошибки
 * @param {string} fieldName - имя валидируемого поля, если значение является массивом объектов
 * @returns {Validator}
 */
export const regExpValidator = (regExp: RegExp, errorText: string = t('validation.doesNotMatchRegExp'), fieldName?: string): Validator => {
    return (value: string | number): ValidationResult => {
        if (!value && value !== 0) return { valid: true }

        const isValid = (rule: boolean): ValidationResult => {
            if (rule) {
                return {
                    valid: false,
                    error: errorText,
                }
            } else {
                return {
                    valid: true
                }
            }
        }

        if (Array.isArray(value)) {
            const errorIndices: number[] = value.reduce((indices, current, index) => {
                if (!regExp.test(current[fieldName])) {
                    indices.push(index)
                    return indices
                }
                return indices
            }, [])

            return isValid(errorIndices.length > 0)
        }

        const stringValue: string = String(value)
        return isValid(!regExp.test(stringValue))
    }
}

export const russianPhoneValidator: Validator = regExpValidator(russianPhoneRegexp, 'Неверный формат номера телефона')
export const emailValidator: Validator = regExpValidator(emailRegexp, 'Неверный формат email')
export const firstNameValidator: Validator = regExpValidator(nameRegexp, 'Неверный формат имени')
export const lastNameValidator: Validator = regExpValidator(nameRegexp, 'Неверный формат фамилии')
export const middleNameValidator: Validator = regExpValidator(nameRegexp, 'Неверный формат отчества')
export const nameValidator: Validator = regExpValidator(nameRegexp, 'Неверный формат')
export const childrenNameValidator: Validator = regExpValidator(childNameRegexp, 'Неверный формат имени', 'name')

